module.exports = __webpack_public_path__ + "assets/img/SEOClarity-Landing-Page-+-Website-w540.7edd5040.jpg";